import { CreateDashboardInput } from '@akin-home/amplify';
import { DashboardModel } from '@akin-home/dashboards';

export const dashboardModelToCreateInput = (
  dashboard: DashboardModel
): CreateDashboardInput => {
  return {
    name: dashboard.name,
    description: dashboard.description,
    device_type: dashboard.device_type,
    user_id: dashboard.user_id === '' ? null : dashboard.user_id,
    read_accounts: dashboard.read_accounts,
    read_groups: dashboard.read_groups,
    full_access_groups: dashboard.full_access_groups,
    layout: dashboard.layout ? JSON.stringify(dashboard.layout) : undefined,
    owner: dashboard.owner,
  };
};
